import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { UserRow, CreateUserRequest, CreateUserResponse, RegenerateUserResponse } from '@/api/types'
import { queryKeys } from '@/lib/queryKeys'

export function useUsers() {
  return useQuery({
    queryKey: queryKeys.users.list(),
    queryFn: () => api.get<UserRow[]>('/admin/users'),
  })
}

export function useCreateUser() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: CreateUserRequest) => api.post<CreateUserResponse>('/admin/users', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.users.all })
      queryClient.invalidateQueries({ queryKey: queryKeys.dashboard })
    },
  })
}

export function useDeleteUser() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => api.delete<string>(`/admin/users/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.users.all })
      queryClient.invalidateQueries({ queryKey: queryKeys.dashboard })
    },
  })
}

export function useRegenerateUser() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => api.post<RegenerateUserResponse>(`/admin/users/${id}/regenerate`, {}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.users.all })
    },
  })
}
